/**
 * i18next Configuration
 *
 * Initializes i18next with French as default/fallback language.
 * Supports French (fr), English (en), and Malagasy (mg).
 * Syncs with Zustand useSettingsStore for language persistence.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import mg from './locales/mg.json';

// Get persisted language from localStorage (Zustand store key)
function getPersistedLanguage(): string {
  try {
    const stored = localStorage.getItem('ludoka-settings');
    if (stored) {
      const parsed: unknown = JSON.parse(stored);
      if (
        parsed &&
        typeof parsed === 'object' &&
        'state' in parsed &&
        parsed.state &&
        typeof parsed.state === 'object' &&
        'language' in parsed.state &&
        typeof parsed.state.language === 'string'
      ) {
        return parsed.state.language;
      }
    }
  } catch {
    // Silently fail and use default
  }
  return 'fr';
}

void i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    mg: { translation: mg }
  },
  lng: getPersistedLanguage(),
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false // React already handles escaping
  },
  debug: false
});

export default i18n;
